module.exports = {
	"config": {
		"colors": [
			"#266093",
			"#6CABD0",
			"#878787",
			"#C6C6C6",
			"#86a5c1",
			"#A31834",
			"#EE7219",
			"#FBBC33",
			"#74B959",
			"#9460A4"
		],
		"selectionMaximum": 7,
		"size": {
			"height": 350,
			"width": 530
		}
	},
	"data": {
		"presets": [],
		"years": [
			2013,
			2014,
			2015
		],
		"units": {
			"млн т н. э.": {
				"ru": "млн т н. э.",
				"en": "mn TOE"
			},
			"%": "%",
			"млн т": {
				"ru": "МВА",
				"en": "MVA"
			},
			"шт": {
				"ru": "шт.",
				"en": "pcs"
			},
			"т/сут.": {
				"ru": "км",
				"en": "km"
			},
			"млрд руб.": {
				"ru": "тыс. руб.",
				"en": "RUB thou."
			},
			"млн руб.": {
				"ru": "млн руб.",
				"en": "RUB mln"
			},
			"руб.": {
				"ru": "руб.",
				"en": "RUB"
			},
			"млн шт.": {
				"ru": "тыс. чел.",
				"en": "thou. persons"
			},
			"руб./барр. н. э.": {
				"ru": "руб./барр. н. э.",
				"en": "RUB/BOE"
			},
			"ratio": {
				"ru": "млн кВтч",
				"en": "mln kWh"
			},
			"LTIFR": {
				"ru": "МВт",
				"en": "MW"
			},
			"чел.": {
				"ru": "чел.",
				"en": "persons"
			}
		},
		"groups": [
			{
				"id": 1,
				"title": {
					"ru": "Финансово-экономические показатели по РСБУ",
					"en": "Financial indicators (RAS)"
				},
				"items": [
					{
						"id": 1,
						"title": {
							"ru": "Выручка",
							"en": "Revenue"
						},
						"units": "млн руб.",
						"values": [
							92947.5,
							86705.2,
							79817.2
						]
					},
					{
						"id": 2,
						"title": {
							"ru": "Себестоимость",
							"en": "Production costs"
						},
						"units": "млн руб.",
						"values": [
							78132.4,
							73947.6,
							68520.1
						]
					},
					{
						"id": 3,
						"title": {
							"ru": "Валовая прибыль",
							"en": "Gross profit"
						},
						"units": "млн руб.",
						"values": [
							14815.1,
							12757.6,
							11297.1
						]
					},
					{
						"id": 4,
						"title": {
							"ru": "Управленческие расходы",
							"en": "Management costs"
						},
						"units": "млн руб.",
						"values": [
							2140.5,
							2107.5,
							2193.8
						]
					},
					{
						"id": 5,
						"title": {
							"ru": "Коммерческие расходы",
							"en": "Selling costs"
						},
						"units": "млн руб.",
						"values": [
							1187.5,
							652.6,
							0
						]
					},
					{
						"id": 6,
						"title": {
							"ru": "Прибыль от продаж",
							"en": "Profit (loss) from sales"
						},
						"units": "млн руб.",
						"values": [
							11487.1,
							9997.5,
							9103.3
						]
					},
					{
						"id": 7,
						"title": {
							"ru": "Проценты к получению",
							"en": "Interest receivable"
						},
						"units": "млн руб.",
						"values": [
							108.2,
							106.7,
							267.3
						]
					},
					{
						"id": 8,
						"title": {
							"ru": "Проценты к уплате",
							"en": "Interest payable"
						},
						"units": "млн руб.",
						"values": [
							2111.6,
							2501.6,
							4195.4
						]
					},
					{
						"id": 9,
						"title": {
							"ru": "Доходы от участия в других организациях",
							"en": "Income from shareholdings"
						},
						"units": "млн руб.",
						"values": [
							19.1,
							38.8,
							17.7
						]
					},
					{
						"id": 10,
						"title": {
							"ru": "Прочие доходы",
							"en": "Other revenues"
						},
						"units": "млн руб.",
						"values": [
							5120,
							6668.8,
							5211.8
						]
					},
					{
						"id": 11,
						"title": {
							"ru": "Прочие расходы",
							"en": "Other expenses"
						},
						"units": "млн руб.",
						"values": [
							12693.4,
							9446.3,
							8440.4
						]
					},
					{
						"id": 12,
						"title": {
							"ru": "Прибыль до налогообложения",
							"en": "Profit (loss) befor tax"
						},
						"units": "млн руб.",
						"values": [
							1929.4,
							4863.9,
							1964.3
						]
					},
					{
						"id": 13,
						"title": {
							"ru": "Налог на прибыль и иные платежи",
							"en": "Income tax and other charges"
						},
						"units": "млн руб.",
						"values": [
							1636.5,
							1538,
							1055.3
						]
					},
					{
						"id": 14,
						"title": {
							"ru": "Чистая прибыль",
							"en": "Net profit"
						},
						"units": "млн руб.",
						"values": [
							292.9,
							3325.9,
							909
						]
					},
					{
						"id": 15,
						"title": {
							"ru": "EBITDA",
							"en": "EBITDA"
						},
						"units": "млн руб.",
						"values": [
							11599.4,
							15740.5,
							15219.2
						]
					}
				]
			},
			{
				"id": 2,
				"title": {
					"ru": "Производственные показатели",
					"en": "Performance indicators"
				},
				"items": [
					{
						"id": 16,
						"title": {
							"ru": "Отпуск электроэнергии в сеть",
							"en": "Electricity supply to the grid"
						},
						"units": "млн кВтч",
						"values": [
							63646.4,
							62802.4,
							62556.3
						]
					},
					{
						"id": 17,
						"title": {
							"ru": "Полезный отпуск электроэнергии (в границах балансовой принадлежности филиалов Компании)",
							"en": "Net electricity supply (withing the balance participation of the Company`s branches)"
						},
						"units": "млн кВтч",
						"values": [
							57814.3,
							57045.1,
							56706
						]
					},
					{
						"id": 18,
						"title": {
							"ru": "Потери электроэнергии",
							"en": "Electrical losses"
						},
						"units": "млн кВтч",
						"values": [
							5832.1,
							5757.3,
							5850.3
						]
					},
					{
						"id": 19,
						"title": {
							"ru": "Объем оказанных услуг по передаче электроэнергии",
							"en": "Amount of electricity transmission services provided"
						},
						"units": "млн кВтч",
						"values": [
							55214.2,
							54398.8,
							54782.5
						]
					},
					{
						"id": 20,
						"title": {
							"ru": "Максимальная присоединенная мощность",
							"en": "Capacity connected"
						},
						"units": "МВт",
						"values": [
							1018,
							1117,
							1137
						]
					}
				]
			},
			{
				"id": 3,
				"title": {
					"ru": "Капитальные вложения",
					"en": "Capital investment"
				},
				"items": [
					{
						"id": 21,
						"title": {
							"ru": "Капиталовложения",
							"en": "Capital investment"
						},
						"units": "млн руб.",
						"values": [
							14425,
							12177,
							12973
						]
					},
					{
						"id": 22,
						"title": {
							"ru": "Ввод линий электропередачи",
							"en": "Commissioning of capacity"
						},
						"units": "км",
						"values": [
							5689,
							5110,
							4785
						]
					},
					{
						"id": 23,
						"title": {
							"ru": "Ввод трансформаторной мощности",
							"en": "Commissioning of capacity"
						},
						"units": "МВА",
						"values": [
							1362,
							1107,
							1228
						]
					}
				]
			},
			{
				"id": 4,
				"title": {
					"ru": "Активы под управлением Компании с учетом лизинга, аренды и оборудования, обслуживаемого по договорам",
					"en": "Assets controlled by Company (Including the lease of and equipment serviced under the contracts)"
				},
				"items": [
					{
						"id": 24,
						"title": {
							"ru": "Подстанции 0,4–110 кВ",
							"en": "Substations"
						},
						"units": "шт.",
						"values": [
							96849,
							98288,
							100545
						]
					},
					{
						"id": 25,
						"title": {
							"ru": "Установленная мощность",
							"en": "Installed capacity"
						},
						"units": "МВА",
						"values": [
							51312,
							52008,
							53674
						]
					},
					{
						"id": 26,
						"title": {
							"ru": "Трансформаторные подстанции 6–10/0,4 кВ",
							"en": "Transformer substations 6–10/0.4 kV"
						},
						"units": "шт.",
						"values": [
							93793,
							95183,
							97336
						]
					},
					{
						"id": 27,
						"title": {
							"ru": "Трансформаторные подстанции 6–10/0,4 кВ",
							"en": "Transformer substations 6–10/0.4 kV"
						},
						"units": "МВА",
						"values": [
							17227,
							17592,
							19013
						]
					},
					{
						"id": 28,
						"title": {
							"ru": "Распределительные пункты 6–10 кВ",
							"en": "Distribution points 6–10 kV"
						},
						"units": "шт.",
						"values": [
							697,
							742,
							837
						]
					},
					{
						"id": 29,
						"title": {
							"ru": "Распределительные пункты 6–10 кВ",
							"en": "Distribution points 6–10 kV"
						},
						"units": "МВА",
						"values": [
							522,
							479,
							418
						]
					},
					{
						"id": 30,
						"title": {
							"ru": "Протяженность воздушных линий 0,4–110 кВ по трассе",
							"en": "Overhead lines ROW length 0.4–110 kV"
						},
						"units": "км",
						"values": [
							378118,
							379144,
							382540
						]
					},
					{
						"id": 31,
						"title": {
							"ru": "Протяженность кабельных линий 0,4–110 кВ",
							"en": "Cable lines length 0.4–110 kV"
						},
						"units": "км",
						"values": [
							13846,
							14259,
							17156
						]
					}
				]
			},
			{
				"id": 5,
				"title": {
					"ru": "Показатели в области взаимодействия с акционерами",
					"en": "Indicators of the shareholder relations"
				},
				"items": [
					{
						"id": 32,
						"title": {
							"ru": "Капитализация",
							"en": "Capitalisation"
						},
						"units": "млн руб.",
						"values": [
							9283.7,
							11546.6,
							8232.5
						]
					},
					{
						"id": 33,
						"title": {
							"ru": "Сумма начисленных дивидендов",
							"en": "Total dividends"
						},
						"units": "тыс. руб.",
						"values": [
							862935,
							75992,
							831693
						]
					},
					{
						"id": 34,
						"title": {
							"ru": "Дивиденд на одну акцию",
							"en": "Dividend per share"
						},
						"units": "руб.",
						"values": [
							0.02044,
							0.0018,
							0.0197
						]
					}
				]
			},
			{
				"id": 6,
				"title": {
					"ru": "Показатели в области персонала",
					"en": "HR indicators"
				},
				"items": [
					{
						"id": 35,
						"title": {
							"ru": "Среднесписочная численность персонала",
							"en": "Average headcount"
						},
						"units": "тыс. чел.",
						"values": [
							31.1,
							29.7,
							29.4
						]
					},
					{
						"id": 36,
						"title": {
							"ru": "Оплата труда и социальные выплаты",
							"en": "Wages and social payments"
						},
						"units": "млн руб.",
						"values": [
							11832.4,
							13068.6,
							13880.2
						]
					}
				]
			},
			{
				"id": 7,
				"title": {
					"ru": "Показатели в области взаимодействия с поставщиками и обществом",
					"en": "Indicators of supplier relations and customer"
				},
				"items": [
					{
						"id": 37,
						"title": {
							"ru": "Объем закупок",
							"en": "Volume of purchases"
						},
						"units": "млн руб.",
						"values": [
							28182.2,
							24273.8,
							27579.8
						]
					},
					{
						"id": 38,
						"title": {
							"ru": "Налоговые платежи",
							"en": "Tax payments"
						},
						"units": "млн руб.",
						"values": [
							5064.5,
							6232.5,
							7702.6
						]
					}
				]
			},
			{
				"id": 8,
				"title": {
					"ru": "Показатели в области охраны труда и окружающей среды",
					"en": "Indicators of labour safety and environmental protection"
				},
				"items": [
					{
						"id": 39,
						"title": {
							"ru": "Затраты на охрану труда",
							"en": "Labour safety costs"
						},
						"units": "млн руб.",
						"values": [
							472.1,
							500.1,
							468.7
						]
					},
					{
						"id": 40,
						"title": {
							"ru": "Количество пострадавших от несчастных случаев на производстве",
							"en": "Number of people injured from production accidents"
						},
						"units": "чел.",
						"values": [
							7,
							5,
							2
						]
					},
					{
						"id": 41,
						"title": {
							"ru": "Затраты на Программу по снижению травматизма сторонних лиц на объектах Компании",
							"en": "Expenses for the Programme for the third party injury risk reduction at the Company`s facilities"
						},
						"units": "млн руб.",
						"values": [
							866.2,
							642.5,
							549.8
						]
					},
					{
						"id": 42,
						"title": {
							"ru": "Случаи травматизма сторонних лиц на объектах Компании",
							"en": "Third party injuries at the Company`s facilities"
						},
						"units": "",
						"values": [
							21,
							16,
							6
						]
					}
				]
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/analysis/config.json
 ** module id = 9
 ** module chunks = 0
 **/